/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as TarefasRouteImport } from './routes/tarefas'
import { Route as RiRouteImport } from './routes/ri'
import { Route as PortfolioRouteImport } from './routes/portfolio'
import { Route as PipelineRouteImport } from './routes/pipeline'
import { Route as OriginacaoRouteImport } from './routes/originacao'
import { Route as DashboardsRouteImport } from './routes/dashboards'
import { Route as ConfigRouteImport } from './routes/config'
import { Route as IndexRouteImport } from './routes/index'
import { Route as RiIndexRouteImport } from './routes/ri.index'
import { Route as PortfolioIndexRouteImport } from './routes/portfolio.index'
import { Route as PipelineIndexRouteImport } from './routes/pipeline.index'
import { Route as RiInvestidoresRouteImport } from './routes/ri.investidores'
import { Route as PortfolioTarefasRouteImport } from './routes/portfolio.tarefas'
import { Route as PipelineTarefasRouteImport } from './routes/pipeline.tarefas'
import { Route as PipelineOriginacaoRouteImport } from './routes/pipeline.originacao'
import { Route as PipelineDashboardsRouteImport } from './routes/pipeline.dashboards'

const TarefasRoute = TarefasRouteImport.update({
  id: '/tarefas',
  path: '/tarefas',
  getParentRoute: () => rootRouteImport,
} as any)
const RiRoute = RiRouteImport.update({
  id: '/ri',
  path: '/ri',
  getParentRoute: () => rootRouteImport,
} as any)
const PortfolioRoute = PortfolioRouteImport.update({
  id: '/portfolio',
  path: '/portfolio',
  getParentRoute: () => rootRouteImport,
} as any)
const PipelineRoute = PipelineRouteImport.update({
  id: '/pipeline',
  path: '/pipeline',
  getParentRoute: () => rootRouteImport,
} as any)
const OriginacaoRoute = OriginacaoRouteImport.update({
  id: '/originacao',
  path: '/originacao',
  getParentRoute: () => rootRouteImport,
} as any)
const DashboardsRoute = DashboardsRouteImport.update({
  id: '/dashboards',
  path: '/dashboards',
  getParentRoute: () => rootRouteImport,
} as any)
const ConfigRoute = ConfigRouteImport.update({
  id: '/config',
  path: '/config',
  getParentRoute: () => rootRouteImport,
} as any).lazy(() => import('./routes/config.lazy').then((d) => d.Route))
const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any).lazy(() => import('./routes/index.lazy').then((d) => d.Route))
const RiIndexRoute = RiIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => RiRoute,
} as any)
const PortfolioIndexRoute = PortfolioIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => PortfolioRoute,
} as any).lazy(() =>
  import('./routes/portfolio.index.lazy').then((d) => d.Route),
)
const PipelineIndexRoute = PipelineIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => PipelineRoute,
} as any).lazy(() =>
  import('./routes/pipeline.index.lazy').then((d) => d.Route),
)
const RiInvestidoresRoute = RiInvestidoresRouteImport.update({
  id: '/investidores',
  path: '/investidores',
  getParentRoute: () => RiRoute,
} as any).lazy(() =>
  import('./routes/ri.investidores.lazy').then((d) => d.Route),
)
const PortfolioTarefasRoute = PortfolioTarefasRouteImport.update({
  id: '/tarefas',
  path: '/tarefas',
  getParentRoute: () => PortfolioRoute,
} as any).lazy(() =>
  import('./routes/portfolio.tarefas.lazy').then((d) => d.Route),
)
const PipelineTarefasRoute = PipelineTarefasRouteImport.update({
  id: '/tarefas',
  path: '/tarefas',
  getParentRoute: () => PipelineRoute,
} as any).lazy(() =>
  import('./routes/pipeline.tarefas.lazy').then((d) => d.Route),
)
const PipelineOriginacaoRoute = PipelineOriginacaoRouteImport.update({
  id: '/originacao',
  path: '/originacao',
  getParentRoute: () => PipelineRoute,
} as any).lazy(() =>
  import('./routes/pipeline.originacao.lazy').then((d) => d.Route),
)
const PipelineDashboardsRoute = PipelineDashboardsRouteImport.update({
  id: '/dashboards',
  path: '/dashboards',
  getParentRoute: () => PipelineRoute,
} as any).lazy(() =>
  import('./routes/pipeline.dashboards.lazy').then((d) => d.Route),
)

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/config': typeof ConfigRoute
  '/dashboards': typeof DashboardsRoute
  '/originacao': typeof OriginacaoRoute
  '/pipeline': typeof PipelineRouteWithChildren
  '/portfolio': typeof PortfolioRouteWithChildren
  '/ri': typeof RiRouteWithChildren
  '/tarefas': typeof TarefasRoute
  '/pipeline/dashboards': typeof PipelineDashboardsRoute
  '/pipeline/originacao': typeof PipelineOriginacaoRoute
  '/pipeline/tarefas': typeof PipelineTarefasRoute
  '/portfolio/tarefas': typeof PortfolioTarefasRoute
  '/ri/investidores': typeof RiInvestidoresRoute
  '/pipeline/': typeof PipelineIndexRoute
  '/portfolio/': typeof PortfolioIndexRoute
  '/ri/': typeof RiIndexRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/config': typeof ConfigRoute
  '/dashboards': typeof DashboardsRoute
  '/originacao': typeof OriginacaoRoute
  '/tarefas': typeof TarefasRoute
  '/pipeline/dashboards': typeof PipelineDashboardsRoute
  '/pipeline/originacao': typeof PipelineOriginacaoRoute
  '/pipeline/tarefas': typeof PipelineTarefasRoute
  '/portfolio/tarefas': typeof PortfolioTarefasRoute
  '/ri/investidores': typeof RiInvestidoresRoute
  '/pipeline': typeof PipelineIndexRoute
  '/portfolio': typeof PortfolioIndexRoute
  '/ri': typeof RiIndexRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexRoute
  '/config': typeof ConfigRoute
  '/dashboards': typeof DashboardsRoute
  '/originacao': typeof OriginacaoRoute
  '/pipeline': typeof PipelineRouteWithChildren
  '/portfolio': typeof PortfolioRouteWithChildren
  '/ri': typeof RiRouteWithChildren
  '/tarefas': typeof TarefasRoute
  '/pipeline/dashboards': typeof PipelineDashboardsRoute
  '/pipeline/originacao': typeof PipelineOriginacaoRoute
  '/pipeline/tarefas': typeof PipelineTarefasRoute
  '/portfolio/tarefas': typeof PortfolioTarefasRoute
  '/ri/investidores': typeof RiInvestidoresRoute
  '/pipeline/': typeof PipelineIndexRoute
  '/portfolio/': typeof PortfolioIndexRoute
  '/ri/': typeof RiIndexRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/config'
    | '/dashboards'
    | '/originacao'
    | '/pipeline'
    | '/portfolio'
    | '/ri'
    | '/tarefas'
    | '/pipeline/dashboards'
    | '/pipeline/originacao'
    | '/pipeline/tarefas'
    | '/portfolio/tarefas'
    | '/ri/investidores'
    | '/pipeline/'
    | '/portfolio/'
    | '/ri/'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/config'
    | '/dashboards'
    | '/originacao'
    | '/tarefas'
    | '/pipeline/dashboards'
    | '/pipeline/originacao'
    | '/pipeline/tarefas'
    | '/portfolio/tarefas'
    | '/ri/investidores'
    | '/pipeline'
    | '/portfolio'
    | '/ri'
  id:
    | '__root__'
    | '/'
    | '/config'
    | '/dashboards'
    | '/originacao'
    | '/pipeline'
    | '/portfolio'
    | '/ri'
    | '/tarefas'
    | '/pipeline/dashboards'
    | '/pipeline/originacao'
    | '/pipeline/tarefas'
    | '/portfolio/tarefas'
    | '/ri/investidores'
    | '/pipeline/'
    | '/portfolio/'
    | '/ri/'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  ConfigRoute: typeof ConfigRoute
  DashboardsRoute: typeof DashboardsRoute
  OriginacaoRoute: typeof OriginacaoRoute
  PipelineRoute: typeof PipelineRouteWithChildren
  PortfolioRoute: typeof PortfolioRouteWithChildren
  RiRoute: typeof RiRouteWithChildren
  TarefasRoute: typeof TarefasRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/tarefas': {
      id: '/tarefas'
      path: '/tarefas'
      fullPath: '/tarefas'
      preLoaderRoute: typeof TarefasRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/ri': {
      id: '/ri'
      path: '/ri'
      fullPath: '/ri'
      preLoaderRoute: typeof RiRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/portfolio': {
      id: '/portfolio'
      path: '/portfolio'
      fullPath: '/portfolio'
      preLoaderRoute: typeof PortfolioRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/pipeline': {
      id: '/pipeline'
      path: '/pipeline'
      fullPath: '/pipeline'
      preLoaderRoute: typeof PipelineRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/originacao': {
      id: '/originacao'
      path: '/originacao'
      fullPath: '/originacao'
      preLoaderRoute: typeof OriginacaoRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/dashboards': {
      id: '/dashboards'
      path: '/dashboards'
      fullPath: '/dashboards'
      preLoaderRoute: typeof DashboardsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/config': {
      id: '/config'
      path: '/config'
      fullPath: '/config'
      preLoaderRoute: typeof ConfigRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/ri/': {
      id: '/ri/'
      path: '/'
      fullPath: '/ri/'
      preLoaderRoute: typeof RiIndexRouteImport
      parentRoute: typeof RiRoute
    }
    '/portfolio/': {
      id: '/portfolio/'
      path: '/'
      fullPath: '/portfolio/'
      preLoaderRoute: typeof PortfolioIndexRouteImport
      parentRoute: typeof PortfolioRoute
    }
    '/pipeline/': {
      id: '/pipeline/'
      path: '/'
      fullPath: '/pipeline/'
      preLoaderRoute: typeof PipelineIndexRouteImport
      parentRoute: typeof PipelineRoute
    }
    '/ri/investidores': {
      id: '/ri/investidores'
      path: '/investidores'
      fullPath: '/ri/investidores'
      preLoaderRoute: typeof RiInvestidoresRouteImport
      parentRoute: typeof RiRoute
    }
    '/portfolio/tarefas': {
      id: '/portfolio/tarefas'
      path: '/tarefas'
      fullPath: '/portfolio/tarefas'
      preLoaderRoute: typeof PortfolioTarefasRouteImport
      parentRoute: typeof PortfolioRoute
    }
    '/pipeline/tarefas': {
      id: '/pipeline/tarefas'
      path: '/tarefas'
      fullPath: '/pipeline/tarefas'
      preLoaderRoute: typeof PipelineTarefasRouteImport
      parentRoute: typeof PipelineRoute
    }
    '/pipeline/originacao': {
      id: '/pipeline/originacao'
      path: '/originacao'
      fullPath: '/pipeline/originacao'
      preLoaderRoute: typeof PipelineOriginacaoRouteImport
      parentRoute: typeof PipelineRoute
    }
    '/pipeline/dashboards': {
      id: '/pipeline/dashboards'
      path: '/dashboards'
      fullPath: '/pipeline/dashboards'
      preLoaderRoute: typeof PipelineDashboardsRouteImport
      parentRoute: typeof PipelineRoute
    }
  }
}

interface PipelineRouteChildren {
  PipelineDashboardsRoute: typeof PipelineDashboardsRoute
  PipelineOriginacaoRoute: typeof PipelineOriginacaoRoute
  PipelineTarefasRoute: typeof PipelineTarefasRoute
  PipelineIndexRoute: typeof PipelineIndexRoute
}

const PipelineRouteChildren: PipelineRouteChildren = {
  PipelineDashboardsRoute: PipelineDashboardsRoute,
  PipelineOriginacaoRoute: PipelineOriginacaoRoute,
  PipelineTarefasRoute: PipelineTarefasRoute,
  PipelineIndexRoute: PipelineIndexRoute,
}

const PipelineRouteWithChildren = PipelineRoute._addFileChildren(
  PipelineRouteChildren,
)

interface PortfolioRouteChildren {
  PortfolioTarefasRoute: typeof PortfolioTarefasRoute
  PortfolioIndexRoute: typeof PortfolioIndexRoute
}

const PortfolioRouteChildren: PortfolioRouteChildren = {
  PortfolioTarefasRoute: PortfolioTarefasRoute,
  PortfolioIndexRoute: PortfolioIndexRoute,
}

const PortfolioRouteWithChildren = PortfolioRoute._addFileChildren(
  PortfolioRouteChildren,
)

interface RiRouteChildren {
  RiInvestidoresRoute: typeof RiInvestidoresRoute
  RiIndexRoute: typeof RiIndexRoute
}

const RiRouteChildren: RiRouteChildren = {
  RiInvestidoresRoute: RiInvestidoresRoute,
  RiIndexRoute: RiIndexRoute,
}

const RiRouteWithChildren = RiRoute._addFileChildren(RiRouteChildren)

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  ConfigRoute: ConfigRoute,
  DashboardsRoute: DashboardsRoute,
  OriginacaoRoute: OriginacaoRoute,
  PipelineRoute: PipelineRouteWithChildren,
  PortfolioRoute: PortfolioRouteWithChildren,
  RiRoute: RiRouteWithChildren,
  TarefasRoute: TarefasRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
